import { render, staticRenderFns } from "./MoDetails.vue?vue&type=template&id=2f89c5fc&scoped=true&"
import script from "./MoDetails.vue?vue&type=script&lang=js&"
export * from "./MoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f89c5fc",
  null
  
)

export default component.exports